module.exports = __webpack_public_path__ + "img/tab-lottery-active.ac706fcc.png";